import { ICONS } from "@/constants"
import React from "react"
import styled from "styled-components"
import { getCssSizeValue } from "@/utils/utils"
import { BREAKPOINTS, colors } from "@/styles/themeSettings"
import useGlobals from "@/hooks/useGlobals"
import SimpleIconButton, { SIMPLE_ICON_BUTTON_CLASS_NAME, SIMPLE_ICON_BUTTON_VARIANTS } from "@/components/common/SimpleIconButton"

const ResetFiltration = styled.div`
	cursor: pointer;
	display: flex;
	align-items: center;
	color: ${({ theme }) => theme.colors.richBlue} !important;
	gap: ${getCssSizeValue(8, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		gap: ${getCssSizeValue(10)};
	}

	.${SIMPLE_ICON_BUTTON_CLASS_NAME} {
		display: none;

		@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
			display: grid;
		}
	}

	div {
		line-height: normal;
		font-weight: 500 !important;
	}
`

export default function FiltersReset({ isFilterApplied, handleResetFiltration }) {
	const resetNewsFiltrationText = useGlobals((state) => state.resetNewsFiltrationText)

	return (
		isFilterApplied && (
			<ResetFiltration className="col-desktop-4 col-mobile-8" onClick={handleResetFiltration}>
				<SimpleIconButton name={ICONS.CLOSE} variant={SIMPLE_ICON_BUTTON_VARIANTS.SMALL} color={colors.richBlue} />
				<div className="typo-strawford typo-strawford-45">{resetNewsFiltrationText}</div>
			</ResetFiltration>
		)
	)
}
